import React, { Component } from "react";
import { connect } from "react-redux";
import * as postActions from "../../store/action/post";
import * as configActions from "../../store/action/config";

import Link from "src/components/link";
import Select from "react-select";
import * as _ from "lodash";
import ApiService from "../../services/ApiService";
import localStorage from "../../utils/local-storage";
import Input from "../../components/input/Input";
import { filtersToUlr, buildCategoryDropDown } from "../../utils/post-filter";
import "../posts/post.scss";
import Pagination from "react-js-pagination";
import DateRangePicker from "@wojtekmaj/react-daterange-picker";
import { DraggableAreasGroup } from 'react-draggable-tags'
import moment from "moment";
import RoyaltiesReportItem from "../../components/royalties-report/royalties-report-item";
import HeaderMobileComponent from "src/components/layout/header-mobile";
import Spinner from "react-bootstrap/Spinner";
import { confirmAlert } from "react-confirm-alert"; // Import
import "react-confirm-alert/src/react-confirm-alert.css"; // Import css
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ScreenSize from "../../services/screenSize";
import RoyaltiesEditorService from "../../services/RoyaltiesEditorService";
import ContentPennameService from "../../services/ContentPennameService";
import slug from '@sindresorhus/slugify';
import ReactToPdf from "react-to-pdf";
import DateRangePickerCustom from "../../utils/date-range-picker";
import Export from './export';
import Pageviews from './pageviews';
// import TagRecommendation from '../../components/posts/tab/tag-recommendation';
import CreatorItem from '../../components/posts/tab/creator-item/creator-item';
import { filtersToQueryString } from "../../utils/post-filter";

const group = new DraggableAreasGroup();
const DraggableArea1 = group.addArea();
const DraggableArea2 = group.addArea();

const SI_SYMBOL = ["", "k", "tr", "tỉ", "T", "P", "E"];
const ref = React.createRef();
const refGroup = React.createRef();
const options = {
  orientation: 'landscape',
  unit: 'px'
};
const {
  REACT_APP_TITLE
} = process.env;

class RoyaltiesList extends Component {
  isMobile = false;
  constructor(props) {
    super(props);
    const dateinit = this.dateInitFunction();
    this.isMobile = ScreenSize.isMobile;

    this.state = {
      activePage: 1,
      filters: {
        category: {
          fieldName: "categories",
          value: ""
        },
        editor: {
          fieldName: "royalties_editor",
          value: ""
        },
        contentpenname: {
          fieldName: "contentpenname",
          value: ""
        },
        // status: {
        //   fieldName: "type",
        //   value: "da-dang"
        // },
        search: {
          fieldName: "title_search_contains",
          value: ""
        },
        multipletag: {
          fieldName: "multipletag",
          value: ""
        },
        page: {
          fieldName: "_start",
          value: "1"
        },
        limit: {
          fieldName: "_limit",
          value: "50"
        },
        start_date: {
          fieldName: "publishedAt_gte",
          value: dateinit[0]
        },
        end_date: {
          fieldName: "publishedAt_lte",
          value: dateinit[1]
        },
        editor_type: {
          fieldName: "editor_type",
          value: ""
        },
        pay_money: {
          fieldName: "pay_money",
          value: 'yes'
        },
        sort_by: {
          fieldName: "_sort",
          value: "publishedAt:DESC",
        },
        group_by: {
          fieldName: "_group",
          value: "posts",
        }
      },
      categories: [],
      penNames: [],
      contentpennames: [],
      // statuses: [],
      selectedTags: [], listTags: [],
      posts: [],
      totalItemCount: 0,
      totalItemCountVideo: 0,
      date: null,
      dot_nay: null,
      dot_truoc: null,
      post_types: [],
      listRoyaltiesEditor: [],
      listPenname: [],
      listRoyaltiesPhoto: [],
      listTags:[],
      moneyArr: [],
      money: {
        money_editor: 0,
        money_photo: 0,
        total: 0
      },
      canAccess: false,
      isLoadingE: false,
      sortByOptions: [],
      user: null, config: null,
      tags: [],
      isUpdatePageview: false,
      precentUpdatePageview: 0,
      isGroupBy: false,
      groupPosts: [],
      preparingDataGroup: false
    };
  }

  setData(user, config) {
    // if (config.loadConfigStatus == 2) {
      
    // }

  }

  formatNumber(number) {
    var tier = (Math.log10(number) / 3) | 0;
    if (tier == 0) return number;
    var suffix = SI_SYMBOL[tier];
    var scale = Math.pow(10, tier * 3);
    var scaled = number / scale;

    return parseFloat(scaled.toFixed(1)) + suffix;
  }


  componentDidMount() {
    const { user, router, config } = this.props;
    let filters = this.getFiltersFromQuery(router.location.query);
    if(filters && filters["group_by"] && filters["group_by"].value !== "posts"){
      if(filters["group_by"].value === "contentpenname"){
        this.groupByButDanh();
      }
    }
    this.props.getListPost(filters);
    this.props.getListPostMoney(filters);

    if (!config.listRoyaltiesEditor) {
      this.props.getRoyaltiesEditor();
    }

    if (!config.listPenname) {
      this.props.getPennames();
    }

    if (!config.listRoyaltiesPhoto) {
      this.props.getRoyaltiesPhoto();
    }

    if (!config.listTags || config.listTags.length == 0) {
      this.props.getListTag();
    }

    const _user = localStorage.get("_user");
    if (_user.can_view_royalties || _user.can_set_royalties) {
      this.setState({ canAccess: true });
    } else {
      this.confirmAction();
    }

    this.initMonthFilter(filters);
    if (config.listTags) {
      config.listTags.map(tag => {
        if (this.state.colorBg) {
          tag.color = this.state.colorBg[Math.floor(Math.random() * this.state.colorBg.length)]
        }
      });
    }

    this.setState({
      listTags: config.listTags,
      selectedTags: []
    });

    document.title = `${REACT_APP_TITLE} | Nhuận Bút`;
  }

  componentDidUpdate(prevProps) {
    if (JSON.stringify(this.props.config.listCategory) != JSON.stringify(prevProps.config.listCategory)
      || JSON.stringify(this.props.totalMoneyEditor) != JSON.stringify(prevProps.totalMoneyEditor)
      || JSON.stringify(this.props.totalMoney) != JSON.stringify(prevProps.totalMoney)
      || JSON.stringify(this.props.totalMoneyPhoto) != JSON.stringify(prevProps.totalMoneyPhoto)
      || JSON.stringify(this.props.totalPageviews) != JSON.stringify(prevProps.totalPageviews)
      || JSON.stringify(this.props.totalPageviewsVideo) != JSON.stringify(prevProps.totalPageviewsVideo)
    ) {
      this.getConfigs(this.props);
    }

    if (JSON.stringify(this.props.posts) != JSON.stringify(prevProps.posts)
      || JSON.stringify(this.props.totalPosts) != JSON.stringify(prevProps.totalPosts)
      || JSON.stringify(this.props.totalPostsVideo) != JSON.stringify(prevProps.totalPostsVideo)
      || JSON.stringify(this.props.router) != JSON.stringify(prevProps.router)
    ) {
      this.setState({
        posts: this.props.posts,
        totalItemCount: this.props.totalPosts,
        totalItemCountVideo: this.props.totalPostsVideo
      });
    }
  }

  confirmAction() {
    const options = {
      title: "Title",
      message: "Message",
      buttons: [
        {
          label: "Yes",
          onClick: () => alert("Click Yes")
        }
      ],
      childrenElement: () => <div />,
      customUI: ({ onClose }) => (
        <div className="custom-ui-alert">
          <h1>Bạn không có quyền truy cập mục này.</h1>
          <div
            className="bg-c7c6c5 bg-c7c6c5 txt-center pt-3 pb-3"
            onClick={() => {
              onClose();
              this.props.history.push("/");
            }}
          >
            Trở lại
          </div>
        </div>
      ),
      closeOnEscape: false,
      closeOnClickOutside: false
    };

    confirmAlert(options);
  }

  dateInitFunction() {
    const currentDate = moment().date();
    let formatedCurrentDate;
    if (currentDate > 2) { //Sau ngày 2 thì lấy từ ngày 1 đến ngày hiện tại, ngày 30,31,1,2 để chấm nhuận
    //format current date thêm 0
      formatedCurrentDate = currentDate < 10 ? '0' + currentDate : currentDate;
      const dot_nay_b = moment().format("YYYYMM") + formatedCurrentDate;
      const dot_nay_a = moment().format("YYYYMM") + "01";
      return [moment(dot_nay_a).format(), moment(dot_nay_b).format()];
    } else { //Nếu ngày 1,2 thì lấy tháng trước
      const dot_nay_b = moment().subtract(1, "months").endOf('month').format("YYYYMMDD");
      const dot_nay_a =
        moment()
          .subtract(1, "months")
          .format("YYYYMM") + "01";

      return [moment(dot_nay_a).format(), moment(dot_nay_b).format()];
    }
  }

  initMonthFilter(filters) {
    const currentDate = moment().date();
    let formatedCurrentDate;
    if (currentDate > 2) {
      formatedCurrentDate = currentDate < 10 ? '0' + currentDate : currentDate;
      const dot_nay_b = moment().format("YYYYMM") + formatedCurrentDate;
      const dot_nay_a = moment().format("YYYYMM") + "01";
      const dot_truoc_b = moment().subtract(1, "months").endOf('month').format("YYYYMMDD");
      const dot_truoc_a =
        moment()
          .subtract(1, "months")
          .format("YYYYMM") + "01";

      const startDate = filters.start_date.value ? filters.start_date.value : moment(dot_nay_a).format();
      const endDate = filters.end_date.value ? filters.end_date.value : moment(dot_nay_b).format();

      this.setState({
        date: [startDate, endDate],
        dot_nay: [moment(dot_nay_a).format(), moment(dot_nay_b).format()],
        dot_truoc: [moment(dot_truoc_a).format(), moment(dot_truoc_b).format()]
      });
    } else {
      const dot_nay_b = moment().subtract(1, "months").endOf('month').format("YYYYMMDD");
      const dot_nay_a =
        moment()
          .subtract(1, "months")
          .format("YYYYMM") + "01";
      const dot_truoc_b =
        moment()
          .subtract(2, "months").endOf('month')
          .format("YYYYMMDD");
      const dot_truoc_a =
        moment()
          .subtract(2, "months")
          .format("YYYYMM") + "01";

      const startDate = filters.start_date.value ? filters.start_date.value : moment(dot_nay_a).format();
      const endDate = filters.end_date.value ? filters.end_date.value : moment(dot_nay_b).format();
      this.setState({
        date: [startDate, endDate],
        dot_nay: [moment(dot_nay_a).format(), moment(dot_nay_b).format()],
        dot_truoc: [moment(dot_truoc_a).format(), moment(dot_truoc_b).format()]
      });
    }
  }

  selectDot = value => {
    if (value === 1) {
      this.setState({ date: this.state.dot_nay });
      this.addFilter("start_date", this.state.dot_nay[0], false);
      this.addFilter("end_date", this.state.dot_nay[1], true);
    } else if (value === 0) {
      this.setState({ date: this.state.dot_truoc });
      this.addFilter("start_date", this.state.dot_truoc[0], false);
      this.addFilter("end_date", this.state.dot_truoc[1], true);
    } else if (value === -1) {
      this.addFilter("pay_money", 'no', true);
    }
  };

  groupByButDanh = () => {
    this.addFilter("group_by", 'contentpenname', true);
    this.setState({
      isGroupBy: true
    })
    let filters = JSON.parse(JSON.stringify(this.state.filters));
    filters.limit.value = -1;
    let queryString = filtersToQueryString(filters, true);
    this.setState({preparingDataGroup: true}, () => {
          ApiService.get(`/posts/rolyalties?pr_type=0${queryString}`).then(result => {
            // console.log(result);
            let postList = result.posts;
            let lstTmp = [];
            // const grouped = _.groupBy(postList, 'butDanh');
            // trải phẳng contentpenname
            // postList = postList.map((post) => {
            //   post.royalties_editor = post.royalties_editor[0];
            //   return post;
            // })
            const grouped = _.groupBy(postList, post => post.royalties_editor.label);
            console.log(grouped);
            console.log(_.isEmpty(grouped));
            _.forEach(grouped, (items, key) => {
              const countPosts = items.length;
              const totalViews = _.sumBy(items, 'pageviews');
              const totalViewsValue = _.sumBy(items, 'pageviews_value');
              const avgTimeOnPage = _.meanBy(items, 'timeOnPage');
              const listVideo = _.filter(items, item => item.video_url);
              const countPostsVideo = listVideo.length;
              const totalViewsVideo = _.sumBy(listVideo, 'pageviews');
              const avgTimeOnPageVideo = _.meanBy(listVideo, 'timeOnPage');
              const listNonVideo = _.filter(items, item => (!item.video_url || item.video_url == ""));
              const countPostsNonVideo = listNonVideo.length;
              const totalViewsNonVideo = _.sumBy(listNonVideo, 'pageviews');
              const avgTimeOnPageNonVideo = _.meanBy(listNonVideo, 'timeOnPage');
              console.log(`Nhóm: ${key}`, items);
              items.forEach(item => {
                console.log('Item:', item);
              });
              let itemGroup = [key, countPosts, countPostsVideo, countPostsNonVideo, totalViews, totalViewsValue, totalViewsVideo, totalViewsNonVideo, avgTimeOnPage ? avgTimeOnPage.toFixed(2) : 0, avgTimeOnPageVideo ? avgTimeOnPageVideo.toFixed(2) : 0, avgTimeOnPageNonVideo ? avgTimeOnPageNonVideo.toFixed(2) : 0];
              lstTmp.push(itemGroup);
            });
            const sortedLst = lstTmp.sort((a, b) => b[4] - a[4]);
            this.setState({
              preparingDataGroup: false,
              groupPosts: sortedLst
            })
          })
        })
  }
  ungroupByButDanh = () => {
    this.addFilter("group_by", 'posts', true);
    this.setState({
      isGroupBy: false
    })
  }

  selectedFilterDate = value => {
    this.setState({ filterDate: value });
  };

  selectedFilterCategory = selected => {
    let v = selected.value.url;
    this.addFilter("category", v);
  };

  clickChangeCategory = (url) => {
    this.addFilter("category", url);
  }

  clickChangeContentpenname = (url) => {
    this.addFilter("contentpenname", url);
  }

  selectedFilterEditor = selected => {
    let v = selected.value.slug;
    this.addFilter("editor", v);
  };

  selectedFilterPenname = selected => {
    let v = selected.value.slug;
    this.addFilter("contentpenname", v);
  };

  selectedFilterPostType = selected => {
    let v = selected.code;
    this.addFilter("editor_type", v);
  };

  selectedFilterSortBy = selected => {
    let v = selected.value;
    this.addFilter("sort_by", v);
  };

  addFilter(filter, value, execute = true) {
    // console.log(filter);
    let filters = this.resetFilters(filter);
    // console.log(filters);
    filters[filter].value = value;
    this.setState({
      filters: filters,
      posts: []
    }, () => {
      if (execute) {
        let queryString = filtersToUlr(this.state.filters);
        if (queryString != "") {
          queryString = queryString.substr(1, queryString.length - 1);
          this.props.history.push(`/nhuan?${queryString}`);
        } else {
          this.props.history.push(`/nhuan`);
        }

        this.props.getListPost(this.state.filters);
        this.props.getListPostMoney(this.state.filters);
      }
    });
  }

  resetFilters(filter) {
    let { filters } = this.state;
    if (filter == "search") {
      for (const key in filters) {
        if (filters.hasOwnProperty(key)) {
          filters[key].value = "";
        }
      }
    } else {
      filters.page.value = 1;
      filters.search.value = "";

    }

    // if (filter == "multipletag") {
    //   for (const key in filters) {
    //     if (filters.hasOwnProperty(key)) {
    //       filters[key].value = "";
    //     }
    //   }
    // } else {
    //   filters.page.value = 1;
    //   filters.multipletag.value = "";

    // }

    if (filter != 'page') {
      filters.pay_money.value = "yes";
    }

    return filters;
  }

  searchPosts(keyword) {
    this.setState({ posts: [] });
    this.addFilter("search", keyword);
  }

  searchTagPosts = value => {
    let { tags } = this.state;
    if(tags){
      let multipletag = tags.map(tag => tag.slug).join(',');
      // console.log(multipletag);
      this.setState({ posts: [] });
      this.addFilter("multipletag", multipletag);
    }
  }
  setSelectedValue = value => {
    // console.log(value);
    if(value){
      this.setState({ tags: value });
    }
  }

  onChange = date => {
    this.setState({ date });
    let start_date = "";
    let end_date = "";
    if (date) {
      start_date = moment(date[0]).format();
      end_date = moment(date[1]).format();
    }
    this.addFilter("start_date", start_date, false);
    this.addFilter("end_date", end_date, true);
  };

  handlePageChange = pageNumber => {
    this.addFilter("page", pageNumber);
  };

  handleUpdatePostListPageview = () => {
    const pageNumber = this.state.filters.page.value;
    this.addFilter("page", pageNumber);
    this.setState({
      isUpdatePageview: false
    })
  }
  handleStartUpdatePostListPageview = () => {
    this.setState({
      isUpdatePageview: true
    })
  }
  handleUpdateItemPostPageview = (precent) => {
    this.setState({
      precentUpdatePageview: precent
    })
  }

  getConfigs(props) {
    const {
      config = {},
      profile = {},
      posts,
      totalMoney,
      totalPageviews,
      totalPageviewsVideo,
      totalMoneyEditor,
      totalMoneyPhoto
    } = props || this.props;
    // const { statuses = [] } = profile;
    const {
      listContentCreator = [],
      listCategory = [],
      listTags = [],
      listRoyaltiesEditor = [],
      listRoyaltiesPhoto = [],
      listPenname = []
    } = config;
    // console.log(config)
    const { post_types = [] } = config;

    const { penname = [] } = listRoyaltiesEditor || [];

    let buildCate = buildCategoryDropDown(listCategory, config.channels);
    let fCategories = [{ label: "Tất cả chuyên mục", value: { url: "" } }];
    fCategories = fCategories.concat(buildCate);

    let fEditor = [{ label: "Tất cả biên tập", value: { slug: "" } }];

    let fPenname = [{ label: "Tất cả bút danh", value: { slug: "" } }];

    if (listRoyaltiesEditor && listRoyaltiesEditor.length > 0) {
      _.map(listRoyaltiesEditor, item => {
        return (item.value = item);
      });
    }

    if (listPenname && listPenname.length > 0) {
      _.map(listPenname, item => {
        return (item.value = item);
      });
    }

    fEditor = fEditor.concat(listRoyaltiesEditor);

    fPenname = fPenname.concat(listPenname);

    let fPhoto = [];

    if (listRoyaltiesPhoto && listRoyaltiesPhoto.length > 0) {
      _.map(listRoyaltiesPhoto, item => {
        return (item.value = item);
      });
    }

    fPhoto = fPhoto.concat(listRoyaltiesPhoto);


    // const postStatus = [
    //   { value: "", label: "Tất cả bài viết" },
    //   { value: "bai-cua-toi", label: "Bài viết của tôi" },
    //   { value: "da-dang", label: "Đã đăng" },
    //   { value: "da-len-lich", label: "Đã lên lịch" },
    //   { value: "cho-duyet", label: "Chờ duyệt" },
    //   { value: "nhap", label: "Nháp" },
    //   { value: "thung-rac", label: "Thùng rác" }
    // ];

    const postTypes = [
      { value: "", label: "Tất cả loại bài", code: "" },
      { value: "normal", label: "Bài thường", code: "normal" },
      { value: "mini", label: "Bài mini", code: "mini" },
      { value: "special", label: "Bài Special", code: "special" },
      // { value: "video", label: "Bài Video", code: "video" },
      { value: 'pr', label: 'Bài PR', code: 'pr' }
    ];
    const sortByOptions = [
      { value: "publishedAt:DESC", label: "Thời gian xuất bản" },
      { value: "pageviews:DESC,publishedAt:DESC", label: "View cao tới thấp" },
      { value: "pageviews:ASC,publishedAt:DESC", label: "View thấp tới cao" }
    ];

    let money = {
      money_editor: totalMoneyEditor || 0,
      money_photo: totalMoneyPhoto || 0,
      total: totalMoney || 0
    };

    this.setState({
      categories: fCategories,
      penNames: fEditor,
      listPenname: fPenname,
      // statuses: postStatus,
      post_types: postTypes,
      editor_type: postTypes,
      sortByOptions,
      posts: posts,
      listRoyaltiesEditor: fEditor,
      listRoyaltiesPhoto: fPhoto,
      money: money,
      totalPageviews,
      totalPageviewsVideo
    });
  }

  getFiltersFromQuery(query) {
    let filtersQuery = {};
    let { filters } = this.state;

    for (const key in query) {
      if (query.hasOwnProperty(key)) {
        const value = query[key];
        if (value && value != "") {
          filtersQuery[key] = {
            ...this.state.filters[key],
            value: value
          };
        }
      }
    }

    filters = _.merge(filters, filtersQuery);
    this.setState({ filters: filters });
    return filters;
  }

  getSelectedItemOfCategory() {
    if (this.state.filters.category.value == "") {
      return this.state.categories.length > 0 && this.state.categories[0];
    }
    return this.state.categories.find(
      item => item.value.url == this.state.filters.category.value
    );

  }

  getSelectedItemOfEditor() {
    if (this.state.filters.editor.value == "" || this.state.penNames.length == 2) {
      return this.state.penNames.length > 0 && this.state.penNames[0];
    }

    return this.state.penNames.find(
      item => item.value.slug == this.state.filters.editor.value
    );
  }

  getSelectedItemOfPenname() {
    if (this.state.filters.contentpenname.value == "" || this.state.listPenname.length == 2) {
      return this.state.listPenname.length > 0 && this.state.listPenname[0];
    }

    return this.state.listPenname.find(
      item => item.value.slug == this.state.filters.contentpenname.value
    );
  }

  // getSelectedItemOfPostStatus() {
  //   if (this.state.filters.status.value == "") {
  //     return this.state.statuses.length > 0 && this.state.statuses[0];
  //   }

  //   return this.state.statuses.find(
  //     item => item.value == this.state.filters.status.value
  //   );
  // }

  getSelectedItemOfPostType() {
    if (this.state.filters.editor_type.value == "") {
      return this.state.post_types.length > 0 && this.state.post_types[0];
    }

    return this.state.post_types.find(
      item => item.value == this.state.filters.editor_type.value
    );
  }
  getSelectedItemOfSortBy() {
    if (this.state.filters.sort_by.value == "") {
      return this.state.sortByOptions.length > 0 && this.state.sortByOptions[0];
    }

    return this.state.sortByOptions.find(
      item => item.value == this.state.filters.sort_by.value
    );
  }

  getSelectedItemOfDate() {
    let { date } = this.state;
    if (
      this.state.filters.start_date.value !== "" &&
      this.state.filters.end_date.value !== ""
    ) {
      date = [
        moment(this.state.filters.start_date.value).format(),
        moment(this.state.filters.end_date.value).format()
      ];
    }
    return date;
  }

  formatNumber(number) {
    var tier = (Math.log10(number) / 3) | 0;
    if (tier == 0) return number;
    var suffix = SI_SYMBOL[tier];
    var scale = Math.pow(10, tier * 3);
    var scaled = number / scale;

    return parseFloat(scaled.toFixed(2)) + suffix;
  }

  handleUpdateTotal = (value, field) => {
    const total = this.state.money.total + value;

    this.setState({
      money: {
        ...this.state.money,
        total,
        ...(field === "editor" && {
          money_editor: this.state.money.money_editor + value
        }),
        ...(field === "photo" && {
          money_photo: this.state.money.money_photo + value
        })
      }
    });
    toast.success("Cập nhật thành công");
  };

  handleOnChangeDateRange = dateRange => {
    const start_date = moment(dateRange.startDate).format();
    const end_date = moment(dateRange.endDate).format();
    this.addFilter("start_date", start_date, false);
    this.addFilter("end_date", end_date, true);
    this.setState({ date: [start_date, end_date] })
    if(this.state.isGroupBy){
      this.groupByButDanh();
    }
  };

  handleInputChangeEditor = (inputValue) => {

    if (inputValue && inputValue.length >= 2) {
      if (this.timeout) clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        const slugValue = slug(inputValue);
        this.setState({ isLoadingE: true })
        RoyaltiesEditorService.slugfilter(slugValue)
          .then(result => {
            result = _.forEach(result, (itm) => {
              let newItem = {
                increment_id: itm.increment_id,
                _id: itm._id,
                label: itm.label,
                slug: itm.slug,
                createdAt: itm.createdAt,
                updatedAt: itm.updatedAt,
                id: itm.id,
              }
              itm.value = newItem;
            })

            this.setState({ listRoyaltiesEditor: result, isLoadingE: false })
          })
          .catch(err => {
            // callback([]);
            return [];
          });
      }, 1000);
    }

  };

  handleInputChangePenname = (inputValue) => {

    if (inputValue && inputValue.length >= 2) {
      if (this.timeout) clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        const slugValue = slug(inputValue);
        this.setState({ isLoadingE: true })
        ContentPennameService.slugfilter(slugValue)
          .then(result => {
            result = _.forEach(result, (itm) => {
              let newItem = {
                increment_id: itm.increment_id,
                _id: itm._id,
                label: itm.label,
                slug: itm.slug,
                createdAt: itm.createdAt,
                updatedAt: itm.updatedAt,
                id: itm.id,
              }
              itm.value = newItem;
            })

            this.setState({ listPenname: result, isLoadingE: false })
          })
          .catch(err => {
            return [];
            // callback([]);
          });
      }, 1000);
    }

  };
  // updateView = async (posts) => {
  //   return await Promise.all(posts.forEach(post => {
  //     const url = post.post_url;
  //     if(!url) {
  //       toast.error(`Không tìm thấy Bài Viết`);
  //       return;
  //     }
  //     let increment_id;
  //     const groupId = /-(\d+)\.html/.exec(url);

  //     if (groupId && groupId[1]) {
  //       increment_id = groupId[1];
  //     }

  //     if(!increment_id) {
  //       toast.error(`Không tìm thấy Bài Viết`);
  //       return;
  //     }
      
  //     GAService.getViewByID(increment_id).then(
  //       result => {
  //         if(result.status){
  //           toast.success(`Đã Update Pageview cho bài viết: ${post.title}`)
  //           // this.setState({
  //           //   pageviews: result.pageviews,
  //           //   timeOnPage: result.timeOnPage
  //           // })
  //         }
  //         else{
  //           toast.error(`Không Update Pageview cho bài viết`);
  //         }
  //       }
  //     );


  //   }));
  // }
  getViewPublicPosts = async (posts) => {

    // console.log(posts);
    const publishPosts = posts.filter(post => post.posttype.type_code === 'ready');
    const ids = [];
    const validData = [];
    publishPosts.map(post => {
      const regexPattern = /-(\d+)\.html$/;
      const idMatch = post.post_url.match(regexPattern);
      if (idMatch) {
        ids.push(idMatch[1]);
        validData.push({
          post_id: post.id,
          id: idMatch[1],
          view: 0
        })
      }
    });
    const stringIds = ids.toString();

    ApiService.get(`/view-by-id?ids=${stringIds}`).then(result => {
      if (result && result.reports[0]) {
        const rows = result.reports[0].data.rows;

        const updatedViewValidData = validData.map(item => {
          rows.map(row => {
            if (row.dimensions[0].includes(item.id)) {
              item.view += parseInt(row.metrics[0].values, 10);
            }
          })

          return item;
        })

        posts.map(post => {
          const viewData = updatedViewValidData.filter(row => row.post_id === post.id)[0];
          post.view = viewData ? viewData.view : null;
        })
      }
    });
  }

  render() {
    const {
      filters = {},
      categories = [],
      penNames = [],
      contentpennames = [],
      posts = [],
      // statuses = [],
      post_types = [],
      sortByOptions = [],
      totalItemCount = 0,
      totalItemCountVideo = 0,
      listRoyaltiesEditor = [],
      listRoyaltiesPhoto = [],
      listPenname = [],
      money = {},
      canAccess,
      isLoadingE,
      totalPageviews,
      totalPageviewsVideo,
      tags,
      selectedTags,
      listTags,
      isGroupBy,
      preparingDataGroup,
      groupPosts
    } = this.state;

    return (
      <div className="content-wrapper post-list-container">
        <HeaderMobileComponent />

        {/* Post List */}
        {canAccess && (
          <section
            className={
              "content " + (this.isMobile ? "list-mobile list-royalties" : "")
            }
          >
            <div className="container-fluid">
              <div className="row mt-3">
                <div className="col-12 col-sm-6 col-md-4">
                  <div className="info-box">
                    <span className="info-box-icon bg-info elevation-1">
                      <i className="fas fa-clipboard-list"></i>
                    </span>

                    <div className="info-box-content d-flex justify-content-between">
                      <div>
                        <span className="info-box-text">Tổng Bài Viết</span>
                        <span className="info-box-number">
                          {this.formatNumber(totalItemCount)}
                        </span>
                      </div>
                      <div className="text-right">
                        <span className="info-box-text">Tổng View</span>
                        <span className="info-box-number">
                          {this.formatNumber(totalPageviews)}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="col-12 col-sm-6 col-md-4">
                  <div className="info-box">
                    <span className="info-box-icon bg-success elevation-1">
                      <i className="fas fa-video"></i>
                    </span>

                    <div className="info-box-content d-flex justify-content-between">
                      <div>
                        <span className="info-box-text">Tổng BV có Video</span>
                        <span className="info-box-number">
                          {this.formatNumber(totalItemCountVideo)}
                        </span>
                      </div>
                      <div className="text-right">
                        <span className="info-box-text">Tổng View</span>
                        <span className="info-box-number">
                          {this.formatNumber(totalPageviewsVideo)}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="col-12 col-sm-6 col-md-4">
                  <div className="info-box">
                    <span className="info-box-icon bg-danger elevation-1">
                      <i className="fas fa-video-slash"></i>
                    </span>

                    <div className="info-box-content d-flex justify-content-between">
                      <div>
                        <span className="info-box-text">Tổng BV không Video</span>
                        <span className="info-box-number">
                          {(totalItemCount && totalItemCountVideo) ? this.formatNumber(totalItemCount - totalItemCountVideo) : 0}
                        </span>
                      </div>
                      <div className="text-right">
                        <span className="info-box-text">Tổng View</span>
                        <span className="info-box-number">
                          {(totalPageviews && totalPageviewsVideo) ? this.formatNumber(totalPageviews - totalPageviewsVideo) : 0}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="clearfix hidden-md-up"></div>

                {/*<div className="col-12 col-sm-6 col-md-3">
                  <div className="info-box mb-3">
                    <span className="info-box-icon bg-warning elevation-1">
                      <i className="fas fa-coins"></i>
                    </span>

                    <div className="info-box-content">
                      <span className="info-box-text">Tổng Nhuận</span>
                      <span className="info-box-number">
                        {this.formatNumber(money.total * 1000)}
                      </span>
                    </div>
                  </div>
                </div>*/}
              </div>

              <div className="row">
                <div className="col-12 p-0 p-md-2">
                  <div className="card card-default color-palette-box">
                    {/* Filter By Category and Pen Name */}
                    <div className="card-header">
                      <div className="row">
                        <div className="col-12 col-md-1 my-1 my-md-0 px-3 px-md-2">
                          <Select
                            value={this.getSelectedItemOfPostType()}
                            options={post_types}
                            placeholder="Chọn loại bài viết"
                            onChange={this.selectedFilterPostType}
                          />
                        </div>

                        <div className="col-12 col-md-2 my-1 my-md-0 px-3 px-md-2">
                          <Select
                            value={this.getSelectedItemOfCategory()}
                            options={categories}
                            placeholder="Chọn danh mục"
                            onChange={this.selectedFilterCategory}
                          />
                        </div>
                        <div className="col-12 col-md-2 my-1 my-md-0 px-3 px-md-2">
                          <Select
                            value={this.getSelectedItemOfEditor()}
                            options={listRoyaltiesEditor}
                            onChange={this.selectedFilterEditor}
                            onInputChange={this.handleInputChangeEditor}
                            isLoading={isLoadingE}
                          />
                        </div>
                        <div className="col-12 col-md-1 my-1 my-md-0 px-3 px-md-2">
                          <Select
                            value={this.getSelectedItemOfPenname()}
                            options={listPenname}
                            onChange={this.selectedFilterPenname}
                            onInputChange={this.handleInputChangePenname}
                            isLoading={isLoadingE}
                          />
                        </div>
                        <div className="col-12 col-md-1 my-1 my-md-0 px-3 px-md-2 d-flex">
                          {/*<Input
                            icon="search"
                            placeholder="Tìm theo tags"
                            value={this.state.filters.multipletag.value}
                            onSubmit={value => {
                              this.searchTagPosts(value);
                            }}
                          />*/}
                          <div className="col-10">
                          <CreatorItem creatable={false} functioncall="getListTag" newapi="/tags" valueinstore="listTags" posttype="royaltiestags"
                        type="tags" setSelectedValue={this.setSelectedValue} selectedValue={tags} isClearable={true} placeholder="Tìm theo tags" ismulti={true} />
                        </div>
                        <div className="col-2 mr-1" onClick={e => this.searchTagPosts(tags)}>
                          <div className="input-group h-100">
                            <div className="input-group-append">
                              <span className="input-group-text rounded">
                                <i className="fas fa-search"></i>
                              </span>
                            </div>
                          </div>
                        </div>
                        </div>
                        <div className="col-12 col-md-1 my-1 my-md-0 px-3 px-md-2">
                          <Select
                            value={this.getSelectedItemOfSortBy()}
                            options={sortByOptions}
                            // placeholder="Sắp xếp theo"
                            onChange={this.selectedFilterSortBy}
                          />
                        </div>
                        <div className="col-12 col-md-2 my-1 my-md-0 px-3 px-md-2">
                          <div className="form-group">
                            <div className="input-group">
                              {this.state.dot_nay && (
                                <DateRangePickerCustom
                                  startDate={new Date(this.state.date[0])}
                                  endDate={new Date(this.state.date[1])}
                                  onChange={this.handleOnChangeDateRange}
                                />
                              )}
                            </div>
                          </div>
                        </div>
                        
                        <div className="col-12 col-md-2 my-1 my-md-0 ml-auto px-3 px-md-2">
                          <Input
                            icon="search"
                            placeholder="Tìm kiếm"
                            value={this.state.filters.search.value}
                            onSubmit={value => {
                              this.searchPosts(value);
                            }}
                          />
                        </div>
                      </div>
                      <div className="row my-2">
                        <div className="col-12 col-lg-2 my-1 ml-auto">
                          <button
                            className="btn btn-primary btn-block"
                            onClick={e => this.selectDot(-1)}
                          >
                            <i className="fas fa-pause mr-2"></i>
                            Chưa chấm
                          </button>
                        </div>
                        <div className="col-12 col-lg-2 my-1">
                          <button
                            className="btn btn-primary btn-block"
                            onClick={e => this.selectDot(0)}
                          >
                            <i className="fas fa-backward mr-2"></i>
                            Đợt trước
                          </button>
                        </div>
                        <div className="col-12 col-lg-2 my-1">
                          <button
                            className="btn btn-primary btn-block"
                            onClick={e => this.selectDot(1)}
                          >
                            <i className="fas fa-forward mr-2"></i>
                            Đợt này
                          </button>
                        </div>

                        <div className="col-12 col-lg-2 my-1">
                          <Export filters={this.state.filters} groupPosts={this.state.groupPosts} isGroupBy={this.state.isGroupBy} />
                        </div>
                        <div className="col-12 col-lg-2 my-1">
                          <Pageviews filters={this.state.filters} handleUpdate={this.handleUpdatePostListPageview} handleStartUpdate={this.handleStartUpdatePostListPageview} handleUpdateItemPostPageview={this.handleUpdateItemPostPageview} />
                        </div>
                        <div className="col-12 col-lg-2 my-1">
                          {!isGroupBy &&
                            <button
                              className="btn btn-primary btn-block"
                              onClick={e => this.groupByButDanh()}
                            >
                              <i className="far fa-object-group mr-2"></i>
                              Group By PV
                            </button>
                          }
                          {isGroupBy &&
                            <button
                              className="btn btn-primary btn-block"
                              onClick={e => this.ungroupByButDanh()}
                            >
                              <i className="far fa-object-ungroup mr-2"></i>
                              UnGroup By PV
                            </button>
                          }
                          
                        </div>
                      </div>
                    </div>

                    {/* Post List */}
                    <div className="card-body table-responsive p-0">
                      {this.state.isUpdatePageview &&
                      <div className="py-2">
                        <div className="text-center pb-1">Updating Pageviews...</div>
                        <div className="progress">
                          <div
                            className="progress-bar progress-bar-striped progress-bar-animated bg-success"
                            role="progressbar"
                            style={{ width: `${this.state.precentUpdatePageview}%` }}
                            aria-valuenow={this.state.precentUpdatePageview}
                            aria-valuemin={0}
                            aria-valuemax={100}
                          >
                            <span>{parseFloat(this.state.precentUpdatePageview).toFixed(2)}%</span>
                          </div>
                        </div>
                      </div>
                      }
                      {!isGroupBy &&
                        <table className="table table-striped table-valign-middle" ref={ref}>
                          {!this.isMobile ? (
                            <thead>
                              <tr>
                                <th>Tiêu đề bài viết</th>
                                <th>Ngày xuất bản</th>
                                <th>Chuyên Mục</th>
                                {/*<th>Biên tập</th>*/}
                                <th>Bút danh</th>
                                {/*<th className="text-right">Nhuận bút</th>*/}
                                <th className="text-right">Điểm</th>
                                <th className="text-right">Video</th>
                                {/*<th className="text-right">Tổng</th>*/}
                                <th className="text-right">Thời gian</th>
                                <th className="text-right">
                                  Lượt xem
                                  {filters.sort_by.value === "pageviews:DESC,publishedAt:DESC" && <i className="fa fa-caret-down d-inline pl-1"></i>}
                                  {filters.sort_by.value === "pageviews:ASC,publishedAt:DESC" && <i className="fa fa-caret-up d-inline pl-1"></i>}
                                </th>
                                <th className="text-right">
                                  Pageviews Value
                                  {filters.sort_by.value === "pageviews_value:DESC,publishedAt:DESC" && <i className="fa fa-caret-down d-inline pl-1"></i>}
                                  {filters.sort_by.value === "pageviews_value:ASC,publishedAt:DESC" && <i className="fa fa-caret-up d-inline pl-1"></i>}
                                </th>
                              </tr>
                            </thead>
                          ) : (
                              <thead></thead>
                            )}
                          <tbody>
                            {(posts.length > 0) ? (
                              posts.map((post, idx) => {
                                return (
                                  <RoyaltiesReportItem
                                    postItem={post}
                                    contentcreatortype={this.state.penNames}
                                    key={`${post._id}`}
                                    idx={`${post._idx}`}
                                    updateTotal={this.handleUpdateTotal}
                                    clickChangeCategory={this.clickChangeCategory}
                                    clickChangeContentpenname={this.clickChangeContentpenname}
                                    isMobile={this.isMobile}
                                    listRoyaltiesEditor={listRoyaltiesEditor}
                                    listRoyaltiesPhoto={listRoyaltiesPhoto}
                                  />
                                );
                              })
                            ) : (
                                <tr className="" style={{ height: "500px", position: "relative", backgroundColor: "unset" }}>
                                  <td valign="top" colSpan="8" className="dataTables_empty text-center" style={{ position: "absolute", top: "50%", width: "100%", borderTop: "0" }}>
                                    <Spinner animation="grow" variant="primary" />
                                    <Spinner animation="grow" variant="secondary" />
                                    <Spinner animation="grow" variant="success" />
                                    <Spinner animation="grow" variant="danger" />
                                    <Spinner animation="grow" variant="warning" />
                                    <Spinner animation="grow" variant="info" />
                                    <Spinner animation="grow" variant="light" />
                                    <Spinner animation="grow" variant="dark" />
                                  </td>
                                </tr>
                              )}
                          </tbody>
                        </table>
                      }
                      {isGroupBy && this.state.filters["group_by"].value === "contentpenname" &&
                        <table className="table table-striped table-valign-middle" ref={refGroup}>
                           {!this.isMobile ? (
                            <thead>
                              <tr>
                                <th></th>
                                <th colSpan="3" className="text-center border-left border-right">Số lượng bài viết</th>
                                <th colSpan="4" className="text-center border-left border-right">View</th>
                                <th colSpan="3" className="text-center border-left border-right">Thời gian đọc bài</th>
                              </tr>
                              <tr className="text-center">
                                <th className="text-center border-left border-right">Phóng viên</th>
                                <th className="text-center border-left border-right">Tất cả</th>
                                <th className="text-center border-left border-right">Có Video</th>
                                <th className="text-center border-left border-right">Không Video</th>
                                <th className="text-center border-left border-right">Tất cả</th>
                                <th className="text-center border-left border-right">View Tốt</th>
                                <th className="text-center border-left border-right">Có Video</th>
                                <th className="text-center border-left border-right">Không Video</th>
                                <th className="text-center border-left border-right">Tất cả</th>
                                <th className="text-center border-left border-right">Có Video</th>
                                <th className="text-center border-left border-right">Không Video</th>
                              </tr>
                            </thead>
                          ) : (
                              <thead></thead>
                            )}
                            <tbody className="text-center">
                              {(!preparingDataGroup && !_.isEmpty(groupPosts)) ? (
                                groupPosts.map((post,idx) => {
                                  return (
                                    <tr>
                                      {post.map(item => {
                                        return(
                                          <td>{item}</td>
                                        )
                                        })
                                      }
                                    </tr>
                                  )
                                })
                              ) : (
                                <tr className="" style={{ height: "500px", position: "relative", backgroundColor: "unset" }}>
                                  <td valign="top" colSpan="8" className="dataTables_empty text-center" style={{ position: "absolute", top: "50%", width: "100%", borderTop: "0" }}>
                                    <Spinner animation="grow" variant="primary" />
                                    <Spinner animation="grow" variant="secondary" />
                                    <Spinner animation="grow" variant="success" />
                                    <Spinner animation="grow" variant="danger" />
                                    <Spinner animation="grow" variant="warning" />
                                    <Spinner animation="grow" variant="info" />
                                    <Spinner animation="grow" variant="light" />
                                    <Spinner animation="grow" variant="dark" />
                                  </td>
                                </tr>
                              )}
                            </tbody>
                        </table>
                      }
                    </div>
                  </div>
                </div>
              </div>
              {!isGroupBy && this.state.totalItemCount > 0 && (
                <div className="row">
                  <div className="col-sm-12 col-md-7">

                    <div
                      className="dataTables_paginate paging_simple_numbers"
                      id="example1_paginate"
                    >
                      <Pagination
                        hideDisabled
                        activePage={parseInt(this.state.filters.page.value)}
                        itemsCountPerPage={parseInt(this.state.filters.limit.value)}
                        totalItemsCount={parseInt(this.state.totalItemCount)}
                        pageRangeDisplayed={5}
                        onChange={this.handlePageChange}
                        itemClass="paginate_button page-item"
                        activeClass="active"
                        disabledClass="disabled"
                        itemClassPrev="previous"
                        itemClassNext="next"
                        linkClass="page-link"
                        hideFirstLastPages={true}
                        prevPageText="Trang trước"
                        nextPageText="Trang tiếp theo"
                      />
                    </div>
                  </div>
                </div>
              )}

            </div>
          </section>
        )}
        {/* <button type="button" className="btn btn-sm bg-green" onClick={this.loadList}><i className="fas fa-plus"></i> Viết bài mới</button> */}

        <a href="/posts/new" className="dis-none mobi-dis-block">
          <button
            type="button"
            className="btn btn-lg rounded-circle bg-saostar fixed-bottom-right"
          >
            <i className="fas fa-plus"></i>
          </button>
        </a>
      </div>
    );
  }
}

export default connect(
  store => {
    return {
      profile: store.loginInfo.userInfo,
      router: store.router,
      posts: store.post.listRoyalties,
      totalPosts: store.post.totalRoyalties,
      totalPostsVideo: store.post.totalRoyaltiesVideo,
      totalMoneyEditor: store.post.totalMoneyEditor,
      totalMoneyPhoto: store.post.totalMoneyPhoto,
      totalMoney: store.post.totalMoney,
      totalPageviews: store.post.totalPageviews,
      totalPageviewsVideo: store.post.totalPageviewsVideo,
      config: store.config
    };
  },
  dispatch => {
    return {
      getListPost: (value) => {
        dispatch(postActions.getListRoyalties(value));
      },
      getListPostMoney: (value) => {
        dispatch(postActions.getListRoyaltiesMoney(value));
      },
      countListPost: value => {
        dispatch(postActions.countListPost(value));
      },
      updatePost: value => {
        dispatch(postActions.updatePost(value));
      },
      getPennames: value => {
        dispatch(configActions.getPennames(value));
      },
      getRoyaltiesEditor: value => {
        dispatch(configActions.getRoyaltiesEditor(value));
      },
      getListTag: value => {
        dispatch(configActions.getListTag(value));
      },
      getRoyaltiesPhoto: value => {
        dispatch(configActions.getRoyaltiesPhoto(value));
      }
    };
  }
)(RoyaltiesList);
